module.exports = __webpack_public_path__ + "static/media/us.bd10008d.jpg";